import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
} from 'amazon-cognito-identity-js';
import { EntUserPool, UserPool } from '../../login/services/UserPool';

class ResetPasswordService {
  async resetPassword(username: any, otp: any, newPassword: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });
    return new Promise<any>(async (resolve, reject) => {
      user.forgotPassword({
        onSuccess(data) {
          // successfully initiated reset password request
          resolve(data);
        },
        onFailure(err) {
          reject(err);
        },
      });
    });
  }
  async entResetPassword(username: any, otp: any, newPassword: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });
    return new Promise<any>(async (resolve, reject) => {
      user.forgotPassword({
        onSuccess(data) {
          // successfully initiated reset password request
          resolve(data);
        },
        onFailure(err) {
          reject(err);
        },
      });
    });
  }

  async confirmPassword(username: any, otp: any, newPassword: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });
    return new Promise<any>(async (resolve, reject) => {
      user.confirmPassword(otp, newPassword, {
        onSuccess: () => {
          resolve(true);
        },

        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }
  async entConfirmPassword(username: any, otp: any, newPassword: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });
    return new Promise<any>(async (resolve, reject) => {
      user.confirmPassword(otp, newPassword, {
        onSuccess: () => {
          resolve(true);
        },

        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }

  /**
   * Login
   * @param username
   * @param password
   */
  async login(username: any, password: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          resolve(data);
        },

        onFailure: (err) => {
          reject(err.message);
        },
      });
    });
  }

  /**
   * sendOTP
   * @param username
   */
  async sendOTP(username: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.resendConfirmationCode((err, result) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }
  /**
   * sendOTP
   * @param username
   */
  async entSendOTP(username: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.resendConfirmationCode((err, result) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  /**
   * verifyOTP
   * @param username
   * @param otp
   */
  async verifyOTP(username: any, otp: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.confirmRegistration(otp, true, (err, result) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }
}

export default new ResetPasswordService();
